import * as React from 'react';

import {StackLegacy} from '../layout/stack/stack-legacy';
import {SectionLabel} from '../typography/section-label';

import {EmailSequenceListItem} from './email-sequence-list-item';

// The next edition scheduled to send in the sequence
export type NextEdition = {
    name: string;
    emailTemplate:
        | {
              id: string;
          }
        | null
        | undefined;
};

export type Entity = {
    id: string;
    name: string;
    htmlUrl: string | null | undefined;
};

// The email sequence, personal or drip sequence
export type EmailSequence = {
    id: string;
    name: string;
    htmlUrlPath: string;
    length: number;
    totalSent: number; // Messages -sent- to person (not incl. scheduled),
    sendTime: number | null | undefined;
    nextEdition: NextEdition | null | undefined;
    entity: Entity;
    isPaused?: boolean;
};

export type Props = {
    label: string;
    isDripSequence?: boolean;
    emailSequences: EmailSequence[];
    entityType: 'company' | 'lead' | 'person';
    showPreviewModal: (arg1: string, arg2: string) => void; // Sets showing the edition preview modal,
    onCancelSequenceProgression: (arg1: string) => Promise<any>;
};

export function EmailSequenceProgression(props: Props) {
    return props.emailSequences.length ? (
        <div>
            <SectionLabel>{props.label}</SectionLabel>
            <StackLegacy spacing={8}>
                {props.emailSequences
                    .filter((sequence) => sequence.nextEdition && sequence.sendTime) // Filter to only include active
                    .map((sequence) => {
                        return (
                            <EmailSequenceListItem
                                emailSequence={sequence}
                                isDripSequence={props.isDripSequence}
                                entityType={props.entityType}
                                // @ts-expect-error
                                nextEdition={sequence.nextEdition}
                                // @ts-expect-error
                                sendTime={sequence.sendTime}
                                showPreviewModal={props.showPreviewModal}
                                onCancelSequenceProgression={props.onCancelSequenceProgression}
                                key={sequence.id}
                            />
                        );
                    })}
            </StackLegacy>
        </div>
    ) : (
        <></>
    );
}
